import { render, staticRenderFns } from "./PhenotypeHallmarkMetap.vue?vue&type=template&id=099e31e0&scoped=true"
import script from "./PhenotypeHallmarkMetap.vue?vue&type=script&lang=js"
export * from "./PhenotypeHallmarkMetap.vue?vue&type=script&lang=js"
import style0 from "./PhenotypeHallmarkMetap.vue?vue&type=style&index=0&id=099e31e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099e31e0",
  null
  
)

export default component.exports